function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var Transaction = require('../../lib/saito/transaction')["default"];
var SaitoBackup = require('../../lib/saito/ui/modals/saito-backup/saito-backup');
var shared = require('./shared');
var stickers = require('./sticker-protocol');
var dailyProtocol = require('./daily-protocol');
var _require = require('./sync-status'),
  createSyncStatus = _require.createSyncStatus;
var RATE_LIMIT_MS = 3000;
var RATE_LIMIT_MAX_TRACKED = 5000;
var SNAKE_WALLET_RUNTIME_READY_EVENT = 'snake-wallet-runtime-ready';
var WALLET_BACKUP_MAX_BYTES = 5 * 1024 * 1024;
var WALLET_BALANCE_TIMEOUT_MS = 8000;
var WALLET_CHECK_TIMEOUT = Symbol('snake-wallet-check-timeout');
var WALLET_ROLLBACK_STORAGE_KEY = 'snake-wallet-rollback-v1';
var WALLET_ROLLBACK_VERSION = 1;
var WALLET_ROLLBACK_MAX_AGE_MS = 15 * 60 * 1000;
var WALLET_ROLLBACK_MAX_BYTES = WALLET_BACKUP_MAX_BYTES + 4096;
var RECEIPT_RECONCILIATION_DELAY_MS = 1000;
var PERFORMANCE_CAPTURE_LIMIT = 40;
var PERFORMANCE_CAPTURE_MAX_BYTES = 128 * 1024;
var PERFORMANCE_CAPTURE_MAX_EVENTS = 300;
function performanceRuntimeEnabled() {
  try {
    return typeof process !== 'undefined' && /(^|\/)saito-staging(\/|$)/.test(process.cwd());
  } catch (error) {
    return false;
  }
}
function performanceRequestAllowed(req, runtimeEnabled) {
  if (!runtimeEnabled) return false;
  var headers = req && req.headers || {};
  var host = String(headers.host || '').trim().toLowerCase();
  return host === 'saitostaging.davidengelen.nl' || host === 'saitostaging.davidengelen.nl:443' || host === '172.22.0.1:12102';
}
function sanitizePerformanceRecord(value) {
  var maxKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 48;
  if (!value || _typeof(value) !== 'object' || Array.isArray(value)) return null;
  var clean = {};
  var _iterator = _createForOfIteratorHelper(Object.entries(value).slice(0, maxKeys)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        item = _step$value[1];
      if (!/^[A-Za-z][A-Za-z0-9_]{0,39}$/.test(key)) continue;
      if (typeof item === 'number' && Number.isFinite(item) && Math.abs(item) <= 1e15) {
        clean[key] = item;
      } else if (typeof item === 'boolean') {
        clean[key] = item;
      } else if (typeof item === 'string') {
        clean[key] = item.slice(0, 200);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return clean;
}
function normalizePerformanceCapture(value) {
  if (!value || _typeof(value) !== 'object' || Array.isArray(value)) return null;
  var encoded;
  try {
    encoded = JSON.stringify(value);
  } catch (error) {
    return null;
  }
  if (!encoded || encoded.length > PERFORMANCE_CAPTURE_MAX_BYTES) return null;
  if (value.version !== 1 || typeof value.sessionId !== 'string' || !/^[A-Za-z0-9_-]{1,80}$/.test(value.sessionId) || typeof value.runId !== 'string' || !/^[A-Za-z0-9_-]{1,120}$/.test(value.runId) || !Number.isFinite(value.startedAt) || value.startedAt < 0 || !Number.isFinite(value.durationMs) || value.durationMs < 0 || value.durationMs > 86400000 || !Array.isArray(value.events) || value.events.length > PERFORMANCE_CAPTURE_MAX_EVENTS) {
    return null;
  }
  var events = [];
  var _iterator2 = _createForOfIteratorHelper(value.events),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var rawEvent = _step2.value;
      var event = sanitizePerformanceRecord(rawEvent, 32);
      if (!event || typeof event.type !== 'string' || !event.type || typeof event.t !== 'number' || event.t < -10000 || event.t > 86400000) {
        return null;
      }
      events.push(event);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var meta = sanitizePerformanceRecord(value.meta);
  var summary = sanitizePerformanceRecord(value.summary);
  if (!meta || !summary) return null;
  return {
    version: 1,
    clientBuild: typeof value.clientBuild === 'string' ? value.clientBuild.slice(0, 80) : '',
    sessionId: value.sessionId,
    runId: value.runId,
    reason: typeof value.reason === 'string' ? value.reason.slice(0, 40) : '',
    startedAt: value.startedAt,
    durationMs: value.durationMs,
    meta: meta,
    summary: summary,
    events: events
  };
}
function walletFailure(code) {
  var stage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'validation';
  return Object.freeze({
    ok: false,
    code: code,
    stage: stage
  });
}
function normalizeBlockEvidence(block, observedAt) {
  if (!block || !Number.isSafeInteger(observedAt) || observedAt < 0) return null;
  var hash = block.hash;
  if ((!hash || typeof hash !== 'string') && typeof block.returnHash === 'function') {
    try {
      hash = block.returnHash();
    } catch (error) {
      return null;
    }
  }
  var blockId = Number(block.id);
  if (!Number.isSafeInteger(blockId) || blockId < 0 || typeof hash !== 'string' || !/^[a-f0-9]{64}$/i.test(hash)) {
    return null;
  }
  return Object.freeze({
    blockId: blockId,
    blockHash: hash.toLowerCase(),
    observedAt: observedAt
  });
}
function loadServerLeaderboard() {
  // The lite bundler removes module web/ directories. Keep the replay verifier
  // and its game-core dependency in the server runtime only. A direct eval
  // resolves Node's local CommonJS require without giving Webpack a dependency
  // it can pull into the browser bundle.
  return eval('require')('./leaderboard');
}
function loadServerRunStorage() {
  return eval('require')('./run-storage');
}
function loadServerReceiptService() {
  return eval('require')('./receipt-service');
}
var Snake = /*#__PURE__*/function (_ModTemplate) {
  function Snake(app) {
    var _this;
    _classCallCheck(this, Snake);
    _this = _callSuper(this, Snake, [app]);
    _this.app = app;
    _this.syncStatus = createSyncStatus(app);
    _this.name = 'Snake';
    _this.slug = 'snake';
    _this.description = 'Classic snake game served from your own Saito node';
    _this.categories = 'Games Entertainment';
    _this.dbname = 'snake';
    _this.submissionTimes = new Map();
    _this.performanceCaptures = [];
    _this.performanceCaptureEnabled = performanceRuntimeEnabled();
    _this.runStorageReady = false;
    _this.runStorageError = null;
    _this.receiptReconciliationTimer = null;
    _this.receiptReconciliationPromise = null;
    _this.receiptReconciliationDelayMs = RECEIPT_RECONCILIATION_DELAY_MS;
    _this.saitoBackup = null;
    _this.walletImportCandidate = null;
    _this.walletBalanceTimeoutMs = WALLET_BALANCE_TIMEOUT_MS;
    _this.walletBalanceFetcher = null;
    _this.walletRecoveryStorage = app && app.walletRecoveryStorage ? app.walletRecoveryStorage : null;
    _this.walletNow = function () {
      return Date.now();
    };
    _this.walletRecoveryState = 'unchecked';
    _this.walletRecoveryPromise = null;
    _this.walletActivationRunning = false;
    _this.walletBackupProof = null;
    _this.stickerService = null;
    _this.stickerWalletSync = null;
    return _this;
  }

  //
  // sql/leaderboard.sql covers a fresh install; this repeats the same
  // idempotent statements so an already-installed node picks the table up
  // without waiting for a reinstall.
  //
  _inherits(Snake, _ModTemplate);
  return _createClass(Snake, [{
    key: "installModule",
    value: function () {
      var _installModule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (app.BROWSER !== 1) eval('require')('./snake-storage').installSnakeStorage(app.storage);
              return _context.a(2, _superPropGet(Snake, "installModule", this, 3)([app]));
          }
        }, _callee, this);
      }));
      function installModule(_x) {
        return _installModule.apply(this, arguments);
      }
      return installModule;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _eval, StickerService, _eval2, DailyService, _t, _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Snake, "initialize", this, 3)([app]);
            case 1:
              if (!(app.BROWSER === 1)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.p = 2;
              eval('require')('./snake-storage').installSnakeStorage(app.storage);
              _context2.n = 3;
              return loadServerRunStorage().initializeRunStorage(app.storage, this.dbname);
            case 3:
              this.runStorageReady = true;
              this.runStorageError = null;
              this.scheduleReceiptReconciliation();
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              this.runStorageReady = false;
              this.runStorageError = 'legacy-migration-verification-failed';
            case 5:
              _context2.p = 5;
              _eval = eval('require')('./sticker-service'), StickerService = _eval.StickerService;
              this.stickerService = new StickerService(app, Transaction);
              _context2.n = 6;
              return this.stickerService.initialize();
            case 6:
              if (!this.runStorageReady) {
                _context2.n = 10;
                break;
              }
              _eval2 = eval('require')('./daily-service'), DailyService = _eval2.DailyService;
              _context2.p = 7;
              this.stickerService.daily = new DailyService(this.stickerService);
              _context2.n = 8;
              return this.stickerService.daily.initialize();
            case 8:
              _context2.n = 10;
              break;
            case 9:
              _context2.p = 9;
              _t2 = _context2.v;
              this.stickerService.daily = null;
              this.stickerService.economy.beforeNewAwards = null;
            case 10:
              this.stickerService.start();
              _context2.n = 12;
              break;
            case 11:
              _context2.p = 11;
              _t3 = _context2.v;
            case 12:
              return _context2.a(2);
          }
        }, _callee2, this, [[7, 9], [5, 11], [2, 4]]);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var recovery, modSelf, detail;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Snake, "render", this, 3)([app]);
            case 1:
              if (!(!this.browser_active || !app || app.BROWSER !== 1 || typeof window === 'undefined' || typeof window.CustomEvent !== 'function')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.ensureWalletRecovery();
            case 3:
              recovery = _context3.v;
              if (!(recovery && recovery.recovered)) {
                _context3.n = 4;
                break;
              }
              this.requestWalletReload();
              return _context3.a(2);
            case 4:
              modSelf = this;
              if (!this.saitoBackup) {
                this.saitoBackup = new SaitoBackup(app, this);
              }
              detail = Object.freeze({
                signStickerClaim: function signStickerClaim(claim) {
                  return modSelf.signStickerClaim(claim);
                },
                signDailyScore: function signDailyScore(value) {
                  return modSelf.signDailyScore(value);
                },
                syncStickerWallet: function syncStickerWallet(canWork) {
                  return modSelf.syncStickerWallet(canWork);
                },
                getSyncStatus: function getSyncStatus() {
                  return modSelf.syncStatus.read();
                },
                getWalletPublicKey: function getWalletPublicKey() {
                  return typeof modSelf.publicKey === 'string' ? modSelf.publicKey : '';
                },
                getWalletSummary: function getWalletSummary() {
                  return modSelf.getWalletSummary();
                },
                downloadWalletBackup: function downloadWalletBackup() {
                  return modSelf.downloadWalletBackup();
                },
                inspectWalletBackup: function inspectWalletBackup(file) {
                  return modSelf.inspectWalletBackup(file);
                },
                clearWalletImportPreview: function clearWalletImportPreview() {
                  return modSelf.clearWalletImportPreview();
                },
                restoreWalletBackup: function restoreWalletBackup() {
                  return modSelf.restoreWalletBackup();
                },
                switchWalletBackup: function switchWalletBackup(warningsAcknowledged) {
                  return modSelf.switchWalletBackup(warningsAcknowledged);
                },
                getRegistryName: function getRegistryName() {
                  try {
                    var identifier = app.keychain.returnIdentifierByPublicKey(modSelf.publicKey);
                    return shared.normalizeRegistryName(identifier);
                  } catch (error) {
                    return '';
                  }
                },
                signScore: function signScore(entry, ownerPublicKey) {
                  return modSelf.signScore(entry, ownerPublicKey);
                },
                propagateScore: function propagateScore(serializedTransaction) {
                  return modSelf.propagateScore(serializedTransaction);
                },
                qualifyIdentity: function qualifyIdentity(rank) {
                  return modSelf.qualifyIdentity(rank);
                },
                identityProtectionAvailable: function identityProtectionAvailable() {
                  return modSelf.identityProtectionAvailable();
                },
                saveIdentity: function saveIdentity() {
                  return modSelf.saveIdentity();
                },
                claimSaitoName: function claimSaitoName() {
                  return modSelf.claimSaitoName();
                }
              });
              window.dispatchEvent(new window.CustomEvent(SNAKE_WALLET_RUNTIME_READY_EVENT, {
                detail: detail
              }));
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render(_x3) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "isWalletPublicKey",
    value: function isWalletPublicKey(value) {
      // 0.3 moved public-key validation from the wallet to core crypto.
      try {
        var _this$app$wallet, _this$app$crypto;
        if (typeof ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.isValidPublicKey) === 'function') {
          return this.app.wallet.isValidPublicKey(value) === true;
        }
        return typeof ((_this$app$crypto = this.app.crypto) === null || _this$app$crypto === void 0 ? void 0 : _this$app$crypto.isPublicKey) === 'function' && this.app.crypto.isPublicKey(value) === true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "signDailyScore",
    value: function () {
      var _signDailyScore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(value) {
        var _this$app;
        var message, key, _t4, _t5, _t6;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(((_this$app = this.app) === null || _this$app === void 0 ? void 0 : _this$app.BROWSER) !== 1 || this.walletActivationRunning)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, null);
            case 1:
              message = dailyProtocol.message(value);
              if (message) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, null);
            case 2:
              _context4.p = 2;
              _context4.n = 3;
              return this.app.wallet.getPublicKey();
            case 3:
              _t4 = _context4.v;
              _t5 = value.owner;
              if (!(_t4 !== _t5)) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2, null);
            case 4:
              _context4.n = 5;
              return this.app.wallet.getPrivateKey();
            case 5:
              key = _context4.v;
              if (!(this.walletActivationRunning || this.app.crypto.generatePublicKey(key) !== value.owner)) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2, null);
            case 6:
              return _context4.a(2, this.app.crypto.signMessage(message, key));
            case 7:
              _context4.p = 7;
              _t6 = _context4.v;
              return _context4.a(2, null);
          }
        }, _callee4, this, [[2, 7]]);
      }));
      function signDailyScore(_x4) {
        return _signDailyScore.apply(this, arguments);
      }
      return signDailyScore;
    }()
  }, {
    key: "signStickerClaim",
    value: function () {
      var _signStickerClaim = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(claim) {
        var _this$app2;
        var message, key, _t7, _t8, _t9;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(((_this$app2 = this.app) === null || _this$app2 === void 0 ? void 0 : _this$app2.BROWSER) !== 1 || this.walletActivationRunning)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, null);
            case 1:
              message = stickers.claimMessage(claim);
              if (message) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, null);
            case 2:
              _context5.p = 2;
              _context5.n = 3;
              return this.app.wallet.getPublicKey();
            case 3:
              _t7 = _context5.v;
              _t8 = claim.owner;
              if (!(_t7 !== _t8)) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2, null);
            case 4:
              _context5.n = 5;
              return this.app.wallet.getPrivateKey();
            case 5:
              key = _context5.v;
              if (!(this.walletActivationRunning || this.app.crypto.generatePublicKey(key) !== claim.owner)) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2, null);
            case 6:
              return _context5.a(2, this.app.crypto.signMessage(message, key));
            case 7:
              _context5.p = 7;
              _t9 = _context5.v;
              return _context5.a(2, null);
          }
        }, _callee5, this, [[2, 7]]);
      }));
      function signStickerClaim(_x5) {
        return _signStickerClaim.apply(this, arguments);
      }
      return signStickerClaim;
    }()
  }, {
    key: "readStickerRecovery",
    value: function () {
      var _readStickerRecovery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(owner) {
        var response, value, _iterator3, _step3, _nft$slip, item, nft, _t0;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(!stickers.KEY.test(owner) || typeof fetch !== 'function')) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, null);
            case 1:
              _context6.n = 2;
              return fetch('/snake/api/stickers/inventory/' + owner + '?recovery=1', {
                cache: 'no-store',
                signal: AbortSignal.timeout(5000)
              });
            case 2:
              response = _context6.v;
              if (response.ok) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2, null);
            case 3:
              _context6.n = 4;
              return response.json();
            case 4:
              value = _context6.v;
              if (!((value === null || value === void 0 ? void 0 : value.version) !== 1 || value.owner !== owner || !Array.isArray(value.recovery) || value.recovery.length > 2000)) {
                _context6.n = 5;
                break;
              }
              return _context6.a(2, null);
            case 5:
              if (!(!Array.isArray(value.recognizedIds) || value.recognizedIds.length > 50000 || value.recognizedIds.some(function (id) {
                return !/^[a-f0-9]{66}$/.test(id);
              }) || typeof value.balanceSnapshot !== 'string' || value.balanceSnapshot.length > 4 * 1024 * 1024)) {
                _context6.n = 6;
                break;
              }
              return _context6.a(2, null);
            case 6:
              _iterator3 = _createForOfIteratorHelper(value.recovery);
              _context6.p = 7;
              _iterator3.s();
            case 8:
              if ((_step3 = _iterator3.n()).done) {
                _context6.n = 10;
                break;
              }
              item = _step3.value;
              nft = item === null || item === void 0 ? void 0 : item.nft;
              if (!(!nft || ((_nft$slip = nft.slip2) === null || _nft$slip === void 0 ? void 0 : _nft$slip.public_key) !== owner || !/^[a-f0-9]{66}$/.test(nft.id) || !/^[a-f0-9]{128}$/i.test(nft.tx_sig) || typeof item.transaction !== 'string' || item.transaction.length > 1024 * 1024 || [nft.slip1, nft.slip2, nft.slip3].some(function (s) {
                return !s || !/^[a-f0-9]{100,400}$/.test(s.utxo_key);
              }))) {
                _context6.n = 9;
                break;
              }
              return _context6.a(2, null);
            case 9:
              _context6.n = 8;
              break;
            case 10:
              _context6.n = 12;
              break;
            case 11:
              _context6.p = 11;
              _t0 = _context6.v;
              _iterator3.e(_t0);
            case 12:
              _context6.p = 12;
              _iterator3.f();
              return _context6.f(12);
            case 13:
              return _context6.a(2, value);
          }
        }, _callee6, null, [[7, 11, 12, 13]]);
      }));
      function readStickerRecovery(_x6) {
        return _readStickerRecovery.apply(this, arguments);
      }
      return readStickerRecovery;
    }()
  }, {
    key: "syncStickerWallet",
    value: function () {
      var _syncStickerWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this$app3,
          _this2 = this;
        var canWork,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              canWork = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : function () {
                return true;
              };
              if (!(((_this$app3 = this.app) === null || _this$app3 === void 0 ? void 0 : _this$app3.BROWSER) !== 1 || this.walletActivationRunning || typeof canWork !== 'function' || !canWork())) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, false);
            case 1:
              if (!this.stickerWalletSync) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, this.stickerWalletSync);
            case 2:
              this.stickerWalletSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var owner, value, _iterator4, _step4, _loop, _ret, pending, Snapshot, Saito, snapshot, _t15, _t16, _t17, _t18, _t19, _t20, _t21, _t22, _t23;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.p = _context8.n) {
                    case 0:
                      _context8.n = 1;
                      return _this2.app.wallet.getPublicKey();
                    case 1:
                      owner = _context8.v;
                      _context8.n = 2;
                      return _this2.readStickerRecovery(owner);
                    case 2:
                      value = _context8.v;
                      _t17 = !value;
                      if (_t17) {
                        _context8.n = 4;
                        break;
                      }
                      _context8.n = 3;
                      return _this2.app.wallet.getPublicKey();
                    case 3:
                      _t18 = _context8.v;
                      _t19 = owner;
                      _t17 = _t18 !== _t19;
                    case 4:
                      _t16 = _t17;
                      if (_t16) {
                        _context8.n = 5;
                        break;
                      }
                      _t16 = _this2.walletActivationRunning;
                    case 5:
                      _t15 = _t16;
                      if (_t15) {
                        _context8.n = 6;
                        break;
                      }
                      _t15 = !canWork();
                    case 6:
                      if (!_t15) {
                        _context8.n = 7;
                        break;
                      }
                      return _context8.a(2, false);
                    case 7:
                      _iterator4 = _createForOfIteratorHelper(value.recovery);
                      _context8.p = 8;
                      _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                        var item, nft, tx, archived, _t1, _t10, _t11, _t12, _t13, _t14;
                        return _regenerator().w(function (_context7) {
                          while (1) switch (_context7.n) {
                            case 0:
                              item = _step4.value;
                              _t1 = _this2.walletActivationRunning || !canWork();
                              if (_t1) {
                                _context7.n = 2;
                                break;
                              }
                              _context7.n = 1;
                              return _this2.app.wallet.getPublicKey();
                            case 1:
                              _t10 = _context7.v;
                              _t11 = owner;
                              _t1 = _t10 !== _t11;
                            case 2:
                              if (!_t1) {
                                _context7.n = 3;
                                break;
                              }
                              return _context7.a(2, {
                                v: false
                              });
                            case 3:
                              nft = item.nft;
                              tx = new Transaction();
                              tx.deserialize_from_web(_this2.app, item.transaction);
                              if (!(tx.signature !== nft.tx_sig)) {
                                _context7.n = 4;
                                break;
                              }
                              return _context7.a(2, {
                                v: false
                              });
                            case 4:
                              _context7.n = 5;
                              return _this2.runBoundedWalletCheck(function () {
                                return _this2.app.storage.saveTransaction(tx, {
                                  field1: 'Snake',
                                  field4: nft.id,
                                  preserve: 1
                                }, 'localhost');
                              });
                            case 5:
                              archived = _context7.v;
                              _t12 = archived === WALLET_CHECK_TIMEOUT || _this2.walletActivationRunning || !canWork();
                              if (_t12) {
                                _context7.n = 7;
                                break;
                              }
                              _context7.n = 6;
                              return _this2.app.wallet.getPublicKey();
                            case 6:
                              _t13 = _context7.v;
                              _t14 = owner;
                              _t12 = _t13 !== _t14;
                            case 7:
                              if (!_t12) {
                                _context7.n = 8;
                                break;
                              }
                              return _context7.a(2, {
                                v: false
                              });
                            case 8:
                              _context7.n = 9;
                              return _this2.app.wallet.addNft(nft.slip1.utxo_key, nft.slip2.utxo_key, nft.slip3.utxo_key, nft.id, nft.tx_sig, '');
                            case 9:
                              return _context7.a(2);
                          }
                        }, _loop);
                      });
                      _iterator4.s();
                    case 9:
                      if ((_step4 = _iterator4.n()).done) {
                        _context8.n = 12;
                        break;
                      }
                      return _context8.d(_regeneratorValues(_loop()), 10);
                    case 10:
                      _ret = _context8.v;
                      if (!_ret) {
                        _context8.n = 11;
                        break;
                      }
                      return _context8.a(2, _ret.v);
                    case 11:
                      _context8.n = 9;
                      break;
                    case 12:
                      _context8.n = 14;
                      break;
                    case 13:
                      _context8.p = 13;
                      _t20 = _context8.v;
                      _iterator4.e(_t20);
                    case 14:
                      _context8.p = 14;
                      _iterator4.f();
                      return _context8.f(14);
                    case 15:
                      _t21 = _this2.walletActivationRunning || !canWork();
                      if (_t21) {
                        _context8.n = 17;
                        break;
                      }
                      _context8.n = 16;
                      return _this2.app.wallet.getPublicKey();
                    case 16:
                      _t22 = _context8.v;
                      _t23 = owner;
                      _t21 = _t22 !== _t23;
                    case 17:
                      if (!_t21) {
                        _context8.n = 18;
                        break;
                      }
                      return _context8.a(2, false);
                    case 18:
                      _context8.n = 19;
                      return _this2.app.wallet.getPendingTxs();
                    case 19:
                      pending = _context8.v;
                      if (!(Array.isArray(pending) && pending.length === 0 && canWork() && !_this2.walletActivationRunning)) {
                        _context8.n = 20;
                        break;
                      }
                      Snapshot = require('saito-js/lib/balance_snapshot')["default"];
                      Saito = require('saito-js/saito')["default"];
                      snapshot = Snapshot.fromString(value.balanceSnapshot);
                      if (!snapshot) {
                        _context8.n = 20;
                        break;
                      }
                      _context8.n = 20;
                      return Saito.getInstance().updateBalanceFrom(snapshot);
                    case 20:
                      _context8.n = 21;
                      return _this2.app.wallet.updateNFTList();
                    case 21:
                      _context8.n = 22;
                      return _this2.app.wallet.saveWallet();
                    case 22:
                      return _context8.a(2, true);
                  }
                }, _callee7, null, [[8, 13, 14, 15]]);
              }))()["catch"](function () {
                return false;
              })["finally"](function () {
                _this2.stickerWalletSync = null;
              });
              return _context9.a(2, this.stickerWalletSync);
          }
        }, _callee8, this);
      }));
      function syncStickerWallet() {
        return _syncStickerWallet.apply(this, arguments);
      }
      return syncStickerWallet;
    }()
  }, {
    key: "normalizeWalletJson",
    value: function normalizeWalletJson(walletJson) {
      if (typeof walletJson !== 'string' || walletJson.length < 2) {
        return walletFailure('WALLET_FILE_NOT_JSON');
      }
      var value;
      try {
        value = JSON.parse(walletJson);
      } catch (error) {
        return walletFailure('WALLET_FILE_NOT_JSON');
      }
      if (!value || _typeof(value) !== 'object' || Array.isArray(value) || !value.wallet || _typeof(value.wallet) !== 'object' || Array.isArray(value.wallet)) {
        return walletFailure('WALLET_FILE_INCOMPATIBLE');
      }
      var publicKey = value.wallet.publicKey;
      var privateKey = value.wallet.privateKey;
      var version = value.wallet.version;
      if (typeof publicKey !== 'string' || publicKey !== publicKey.trim() || publicKey.length < 1 || publicKey.length > 128 || typeof privateKey !== 'string' || privateKey !== privateKey.trim() || privateKey.length < 1 || privateKey.length > 256 || !['number', 'string'].includes(_typeof(version))) {
        return walletFailure('WALLET_FILE_INCOMPATIBLE');
      }
      try {
        if (!this.isWalletPublicKey(publicKey) || !this.app.crypto || typeof this.app.crypto.generatePublicKey !== 'function') {
          return walletFailure('WALLET_FILE_INCOMPATIBLE');
        }
        if (this.app.crypto.generatePublicKey(privateKey) !== publicKey) {
          return walletFailure('WALLET_IMPORT_KEY_MISMATCH');
        }
      } catch (error) {
        return walletFailure('WALLET_FILE_INCOMPATIBLE');
      }
      return Object.freeze({
        ok: true,
        publicKey: publicKey,
        walletJson: walletJson
      });
    }
  }, {
    key: "getWalletSummary",
    value: function () {
      var _getWalletSummary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var recovery, publicKey, registryName, _t24;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (!(!this.app || this.app.BROWSER !== 1 || !this.app.wallet)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, null);
            case 1:
              _context0.n = 2;
              return this.ensureWalletRecovery();
            case 2:
              recovery = _context0.v;
              _context0.p = 3;
              _context0.n = 4;
              return this.app.wallet.getPublicKey();
            case 4:
              publicKey = _context0.v;
              if (!(typeof publicKey !== 'string' || publicKey.length < 1 || publicKey.length > 128)) {
                _context0.n = 5;
                break;
              }
              return _context0.a(2, null);
            case 5:
              registryName = '';
              try {
                registryName = shared.normalizeRegistryName(this.app.keychain.returnIdentifierByPublicKey(publicKey));
              } catch (error) {}
              return _context0.a(2, Object.freeze({
                publicKey: publicKey,
                registryName: registryName,
                recoveryCode: recovery && recovery.ok === false ? recovery.code : ''
              }));
            case 6:
              _context0.p = 6;
              _t24 = _context0.v;
              return _context0.a(2, null);
          }
        }, _callee9, this, [[3, 6]]);
      }));
      function getWalletSummary() {
        return _getWalletSummary.apply(this, arguments);
      }
      return getWalletSummary;
    }()
  }, {
    key: "downloadWalletBackup",
    value: function () {
      var _downloadWalletBackup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var recovery, objectUrl, anchor, walletJson, normalized, currentPublicKey, blob, revoke, _t25;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (!(!this.app || this.app.BROWSER !== 1 || !this.app.wallet || typeof this.app.wallet.exportWallet !== 'function' || typeof window === 'undefined' || !window.document || typeof window.Blob !== 'function' || !window.URL || typeof window.URL.createObjectURL !== 'function')) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2, false);
            case 1:
              _context1.n = 2;
              return this.ensureWalletRecovery();
            case 2:
              recovery = _context1.v;
              if (!(!recovery || recovery.ok !== true)) {
                _context1.n = 3;
                break;
              }
              return _context1.a(2, false);
            case 3:
              objectUrl = '';
              anchor = null;
              _context1.p = 4;
              // Node endpoints belong to the receiving site, not the wallet identity.
              // Empty peers let Saito restore that site's defaults on its next startup.
              walletJson = window.SnakePeerSettings.replacePeers(this.app.wallet.exportWallet(), [], WALLET_BACKUP_MAX_BYTES);
              normalized = this.normalizeWalletJson(walletJson);
              _context1.n = 5;
              return this.app.wallet.getPublicKey();
            case 5:
              currentPublicKey = _context1.v;
              if (!(!normalized.ok || normalized.publicKey !== currentPublicKey)) {
                _context1.n = 6;
                break;
              }
              return _context1.a(2, false);
            case 6:
              blob = new window.Blob([walletJson], {
                type: 'application/json'
              });
              objectUrl = window.URL.createObjectURL(blob);
              if (objectUrl) {
                _context1.n = 7;
                break;
              }
              return _context1.a(2, false);
            case 7:
              anchor = window.document.createElement('a');
              anchor.href = objectUrl;
              anchor.download = "saito-wallet-".concat(currentPublicKey, ".json");
              anchor.hidden = true;
              window.document.body.appendChild(anchor);
              anchor.click();
              _context1.n = 8;
              return this.recordWalletBackupForCandidate();
            case 8:
              if (_context1.v) {
                _context1.n = 9;
                break;
              }
              return _context1.a(2, false);
            case 9:
              return _context1.a(2, true);
            case 10:
              _context1.p = 10;
              _t25 = _context1.v;
              return _context1.a(2, false);
            case 11:
              _context1.p = 11;
              try {
                if (anchor) anchor.remove();
              } catch (error) {}
              if (objectUrl && typeof window.URL.revokeObjectURL === 'function') {
                revoke = function revoke() {
                  try {
                    window.URL.revokeObjectURL(objectUrl);
                  } catch (error) {}
                };
                if (typeof window.setTimeout === 'function') window.setTimeout(revoke, 0);else revoke();
              }
              return _context1.f(11);
            case 12:
              return _context1.a(2);
          }
        }, _callee0, this, [[4, 10, 11, 12]]);
      }));
      function downloadWalletBackup() {
        return _downloadWalletBackup.apply(this, arguments);
      }
      return downloadWalletBackup;
    }()
  }, {
    key: "checkWalletCryptoBalance",
    value: function () {
      var _checkWalletCryptoBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(crypto) {
        var checked, returned, balance, _t26;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              if (!(!crypto || typeof crypto.checkBalance !== 'function' || typeof crypto.returnBalance !== 'function')) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2, 'unknown');
            case 1:
              _context10.p = 1;
              _context10.n = 2;
              return this.runBoundedWalletCheck(function () {
                return crypto.checkBalance();
              });
            case 2:
              checked = _context10.v;
              if (!(checked === WALLET_CHECK_TIMEOUT)) {
                _context10.n = 3;
                break;
              }
              return _context10.a(2, 'unknown');
            case 3:
              returned = crypto.returnBalance();
              balance = Number(returned === undefined || returned === null ? checked : returned);
              if (!(!Number.isFinite(balance) || balance < 0)) {
                _context10.n = 4;
                break;
              }
              return _context10.a(2, 'unknown');
            case 4:
              return _context10.a(2, balance > 0 ? 'positive' : 'zero');
            case 5:
              _context10.p = 5;
              _t26 = _context10.v;
              return _context10.a(2, 'unknown');
          }
        }, _callee1, this, [[1, 5]]);
      }));
      function checkWalletCryptoBalance(_x7) {
        return _checkWalletCryptoBalance.apply(this, arguments);
      }
      return checkWalletCryptoBalance;
    }()
  }, {
    key: "runBoundedWalletCheck",
    value: function () {
      var _runBoundedWalletCheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(operation) {
        var _this3 = this;
        var timeout;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              timeout = null;
              _context11.p = 1;
              _context11.n = 2;
              return Promise.race([Promise.resolve().then(operation), new Promise(function (resolve) {
                timeout = setTimeout(function () {
                  return resolve(WALLET_CHECK_TIMEOUT);
                }, _this3.walletBalanceTimeoutMs);
              })]);
            case 2:
              return _context11.a(2, _context11.v);
            case 3:
              _context11.p = 3;
              if (timeout !== null) clearTimeout(timeout);
              return _context11.f(3);
            case 4:
              return _context11.a(2);
          }
        }, _callee10, null, [[1,, 3, 4]]);
      }));
      function runBoundedWalletCheck(_x8) {
        return _runBoundedWalletCheck.apply(this, arguments);
      }
      return runBoundedWalletCheck;
    }()
  }, {
    key: "checkNativeSaitoBalance",
    value: function () {
      var _checkNativeSaitoBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(publicKey) {
        var fetcher, snapshot, text, lines, balance, _iterator5, _step5, line, columns, _t27, _t28;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              fetcher = this.walletBalanceFetcher || (typeof window !== 'undefined' && typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
              if (!(!fetcher || typeof publicKey !== 'string' || !publicKey)) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2, 'unknown');
            case 1:
              _context13.p = 1;
              _context13.n = 2;
              return this.runBoundedWalletCheck(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
                var response;
                return _regenerator().w(function (_context12) {
                  while (1) switch (_context12.n) {
                    case 0:
                      _context12.n = 1;
                      return fetcher("/balance/".concat(encodeURIComponent(publicKey)), {
                        cache: 'no-store'
                      });
                    case 1:
                      response = _context12.v;
                      if (!(!response || response.ok !== true || typeof response.text !== 'function')) {
                        _context12.n = 2;
                        break;
                      }
                      return _context12.a(2, null);
                    case 2:
                      return _context12.a(2, response.text());
                  }
                }, _callee11);
              })));
            case 2:
              snapshot = _context13.v;
              if (!(snapshot === WALLET_CHECK_TIMEOUT)) {
                _context13.n = 3;
                break;
              }
              return _context13.a(2, 'unknown');
            case 3:
              text = snapshot;
              if (!(typeof text !== 'string' || text.length < 1 || text.length > WALLET_BACKUP_MAX_BYTES)) {
                _context13.n = 4;
                break;
              }
              return _context13.a(2, 'unknown');
            case 4:
              lines = text.trimEnd().split(/\r?\n/);
              if (/^\d+-\d+-[a-f0-9]{64}\.snap$/i.test(lines[0] || '')) {
                _context13.n = 5;
                break;
              }
              return _context13.a(2, 'unknown');
            case 5:
              balance = 0n;
              _iterator5 = _createForOfIteratorHelper(lines.slice(1));
              _context13.p = 6;
              _iterator5.s();
            case 7:
              if ((_step5 = _iterator5.n()).done) {
                _context13.n = 11;
                break;
              }
              line = _step5.value;
              if (line) {
                _context13.n = 8;
                break;
              }
              return _context13.a(3, 10);
            case 8:
              columns = line.trim().split(/\s+/);
              if (!(columns.length !== 6 || columns[0] !== publicKey || !columns.slice(1).every(function (column) {
                return /^\d+$/.test(column);
              }))) {
                _context13.n = 9;
                break;
              }
              return _context13.a(2, 'unknown');
            case 9:
              balance += BigInt(columns[4]);
            case 10:
              _context13.n = 7;
              break;
            case 11:
              _context13.n = 13;
              break;
            case 12:
              _context13.p = 12;
              _t27 = _context13.v;
              _iterator5.e(_t27);
            case 13:
              _context13.p = 13;
              _iterator5.f();
              return _context13.f(13);
            case 14:
              return _context13.a(2, balance > 0n ? 'positive' : 'zero');
            case 15:
              _context13.p = 15;
              _t28 = _context13.v;
              return _context13.a(2, 'unknown');
          }
        }, _callee12, this, [[6, 12, 13, 14], [1, 15]]);
      }));
      function checkNativeSaitoBalance(_x9) {
        return _checkNativeSaitoBalance.apply(this, arguments);
      }
      return checkNativeSaitoBalance;
    }()
  }, {
    key: "assessWalletSwitch",
    value: function () {
      var _assessWalletSwitch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(publicKey) {
        var _this4 = this;
        var balanceState, states, installed, active, activationUnknown, _iterator6, _step6, crypto, pendingState, pending, registryName, _t29, _t30, _t31, _t32, _t33, _t34, _t35, _t36;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              balanceState = 'unknown';
              _context14.p = 1;
              _context14.n = 2;
              return this.checkNativeSaitoBalance(publicKey);
            case 2:
              _t29 = _context14.v;
              states = [_t29];
              installed = this.app.wallet.returnInstalledCryptos(false);
              active = [];
              activationUnknown = false;
              if (Array.isArray(installed)) {
                _context14.n = 3;
                break;
              }
              activationUnknown = true;
              _context14.n = 13;
              break;
            case 3:
              _iterator6 = _createForOfIteratorHelper(installed);
              _context14.p = 4;
              _iterator6.s();
            case 5:
              if ((_step6 = _iterator6.n()).done) {
                _context14.n = 10;
                break;
              }
              crypto = _step6.value;
              _context14.p = 6;
              if (!(crypto && typeof crypto.ticker === 'string' && crypto.ticker.toUpperCase() === 'SAITO')) {
                _context14.n = 7;
                break;
              }
              return _context14.a(3, 9);
            case 7:
              if (!crypto || typeof crypto.ticker !== 'string' || typeof crypto.isActivated !== 'function') activationUnknown = true;else if (crypto.isActivated()) active.push(crypto);
              _context14.n = 9;
              break;
            case 8:
              _context14.p = 8;
              _t30 = _context14.v;
              activationUnknown = true;
            case 9:
              _context14.n = 5;
              break;
            case 10:
              _context14.n = 12;
              break;
            case 11:
              _context14.p = 11;
              _t31 = _context14.v;
              _iterator6.e(_t31);
            case 12:
              _context14.p = 12;
              _iterator6.f();
              return _context14.f(12);
            case 13:
              _t32 = states.push;
              _t33 = states;
              _t34 = _toConsumableArray;
              _context14.n = 14;
              return Promise.all(active.map(function (crypto) {
                return _this4.checkWalletCryptoBalance(crypto);
              }));
            case 14:
              _t32.apply.call(_t32, _t33, _t34(_context14.v));
              if (states.includes('positive')) balanceState = 'positive';else if (!activationUnknown && states.every(function (state) {
                return state === 'zero';
              })) {
                balanceState = 'zero';
              }
              _context14.n = 16;
              break;
            case 15:
              _context14.p = 15;
              _t35 = _context14.v;
            case 16:
              pendingState = 'unknown';
              _context14.p = 17;
              if (!(typeof this.app.wallet.getPendingTransactions === 'function')) {
                _context14.n = 19;
                break;
              }
              _context14.n = 18;
              return this.runBoundedWalletCheck(function () {
                return _this4.app.wallet.getPendingTransactions();
              });
            case 18:
              pending = _context14.v;
              if (pending !== WALLET_CHECK_TIMEOUT && Array.isArray(pending)) {
                pendingState = pending.length > 0 ? 'present' : 'clear';
              }
            case 19:
              _context14.n = 21;
              break;
            case 20:
              _context14.p = 20;
              _t36 = _context14.v;
            case 21:
              registryName = '';
              try {
                registryName = shared.normalizeRegistryName(this.app.keychain.returnIdentifierByPublicKey(publicKey));
              } catch (error) {}
              return _context14.a(2, Object.freeze({
                balanceState: balanceState,
                pendingState: pendingState,
                registryName: registryName
              }));
          }
        }, _callee13, this, [[17, 20], [6, 8], [4, 11, 12, 13], [1, 15]]);
      }));
      function assessWalletSwitch(_x0) {
        return _assessWalletSwitch.apply(this, arguments);
      }
      return assessWalletSwitch;
    }()
  }, {
    key: "inspectWalletBackup",
    value: function () {
      var _inspectWalletBackup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(file) {
        var recovery, walletJson, normalized, currentPublicKey, sameWallet, candidateHash, assessment, _t37, _t38;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              this.walletImportCandidate = null;
              this.walletBackupProof = null;
              _context15.n = 1;
              return this.ensureWalletRecovery();
            case 1:
              recovery = _context15.v;
              if (!(!recovery || recovery.ok !== true)) {
                _context15.n = 2;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'startup_recovery'));
            case 2:
              if (!(!this.app || this.app.BROWSER !== 1 || !file || typeof file.name !== 'string' || !file.name.toLowerCase().endsWith('.json'))) {
                _context15.n = 3;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_FILE_NOT_JSON'));
            case 3:
              if (!(!Number.isSafeInteger(file.size) || file.size < 1 || file.size > WALLET_BACKUP_MAX_BYTES)) {
                _context15.n = 4;
                break;
              }
              return _context15.a(2, walletFailure(file.size > WALLET_BACKUP_MAX_BYTES ? 'WALLET_FILE_TOO_LARGE' : 'WALLET_FILE_INCOMPATIBLE'));
            case 4:
              _context15.p = 4;
              if (!(typeof file.text !== 'function')) {
                _context15.n = 5;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_FILE_INCOMPATIBLE'));
            case 5:
              _context15.n = 6;
              return file.text();
            case 6:
              walletJson = _context15.v;
              _context15.n = 8;
              break;
            case 7:
              _context15.p = 7;
              _t37 = _context15.v;
              return _context15.a(2, walletFailure('WALLET_FILE_NOT_JSON'));
            case 8:
              if (!(typeof walletJson !== 'string' || walletJson.length > WALLET_BACKUP_MAX_BYTES)) {
                _context15.n = 9;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_FILE_TOO_LARGE'));
            case 9:
              normalized = this.normalizeWalletJson(walletJson);
              if (normalized.ok) {
                _context15.n = 10;
                break;
              }
              return _context15.a(2, normalized);
            case 10:
              _context15.p = 10;
              _context15.n = 11;
              return this.app.wallet.getPublicKey();
            case 11:
              currentPublicKey = _context15.v;
              _context15.n = 13;
              break;
            case 12:
              _context15.p = 12;
              _t38 = _context15.v;
            case 13:
              if (!(typeof currentPublicKey !== 'string' || currentPublicKey.length < 1 || currentPublicKey.length > 128)) {
                _context15.n = 14;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_FILE_INCOMPATIBLE'));
            case 14:
              sameWallet = normalized.publicKey === currentPublicKey;
              candidateHash = this.walletCandidateFingerprint(normalized.walletJson);
              if (candidateHash) {
                _context15.n = 15;
                break;
              }
              return _context15.a(2, walletFailure('WALLET_FILE_INCOMPATIBLE'));
            case 15:
              this.walletImportCandidate = Object.freeze({
                walletJson: normalized.walletJson,
                currentPublicKey: currentPublicKey,
                incomingPublicKey: normalized.publicKey,
                sameWallet: sameWallet,
                candidateHash: candidateHash
              });
              assessment = {
                balanceState: 'not_applicable',
                pendingState: 'not_applicable',
                registryName: ''
              };
              if (sameWallet) {
                _context15.n = 17;
                break;
              }
              _context15.n = 16;
              return this.assessWalletSwitch(currentPublicKey);
            case 16:
              assessment = _context15.v;
            case 17:
              return _context15.a(2, Object.freeze({
                ok: true,
                sameWallet: sameWallet,
                currentPublicKey: currentPublicKey,
                incomingPublicKey: normalized.publicKey,
                balanceState: assessment.balanceState,
                pendingState: assessment.pendingState,
                registryName: assessment.registryName
              }));
          }
        }, _callee14, this, [[10, 12], [4, 7]]);
      }));
      function inspectWalletBackup(_x1) {
        return _inspectWalletBackup.apply(this, arguments);
      }
      return inspectWalletBackup;
    }()
  }, {
    key: "clearWalletImportPreview",
    value: function clearWalletImportPreview() {
      this.walletImportCandidate = null;
      this.walletBackupProof = null;
      return true;
    }
  }, {
    key: "walletCandidateFingerprint",
    value: function walletCandidateFingerprint(walletJson) {
      if (!this.app || !this.app.crypto || typeof this.app.crypto.hash !== 'function' || typeof walletJson !== 'string') return '';
      try {
        var digest = this.app.crypto.hash("snake-wallet-candidate:".concat(walletJson));
        return typeof digest === 'string' && /^[a-f0-9]{64}$/i.test(digest) ? digest.toLowerCase() : '';
      } catch (error) {
        return '';
      }
    }
  }, {
    key: "recordWalletBackupForCandidate",
    value: function () {
      var _recordWalletBackupForCandidate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var outgoingPublicKey, candidate, _t39;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              if (!this.walletActivationRunning) {
                _context16.n = 1;
                break;
              }
              return _context16.a(2, false);
            case 1:
              _context16.p = 1;
              _context16.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              outgoingPublicKey = _context16.v;
              candidate = this.walletImportCandidate;
              if (!(typeof outgoingPublicKey !== 'string' || !outgoingPublicKey || candidate && (candidate.currentPublicKey !== outgoingPublicKey || !candidate.candidateHash || candidate.candidateHash !== this.walletCandidateFingerprint(candidate.walletJson)))) {
                _context16.n = 3;
                break;
              }
              return _context16.a(2, false);
            case 3:
              this.walletBackupProof = Object.freeze({
                outgoingPublicKey: outgoingPublicKey,
                incomingPublicKey: candidate ? candidate.incomingPublicKey : '',
                candidateHash: candidate ? candidate.candidateHash : ''
              });
              return _context16.a(2, true);
            case 4:
              _context16.p = 4;
              _t39 = _context16.v;
              return _context16.a(2, false);
          }
        }, _callee15, this, [[1, 4]]);
      }));
      function recordWalletBackupForCandidate() {
        return _recordWalletBackupForCandidate.apply(this, arguments);
      }
      return recordWalletBackupForCandidate;
    }()
  }, {
    key: "walletBackupMatchesCandidate",
    value: function walletBackupMatchesCandidate(candidate, outgoingPublicKey) {
      var proof = this.walletBackupProof;
      return Boolean(proof && candidate && proof.outgoingPublicKey === outgoingPublicKey && proof.incomingPublicKey === candidate.incomingPublicKey && proof.candidateHash === candidate.candidateHash && candidate.candidateHash === this.walletCandidateFingerprint(candidate.walletJson));
    }
  }, {
    key: "getWalletRecoveryStorage",
    value: function getWalletRecoveryStorage() {
      if (this.walletRecoveryStorage) return this.walletRecoveryStorage;
      try {
        if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
      } catch (error) {}
      return null;
    }
  }, {
    key: "walletRollbackIntegrity",
    value: function walletRollbackIntegrity(record) {
      if (!this.app || !this.app.crypto || typeof this.app.crypto.hash !== 'function') return '';
      try {
        var payload = JSON.stringify({
          version: record.version,
          phase: record.phase,
          createdAt: record.createdAt,
          outgoingPublicKey: record.outgoingPublicKey,
          incomingPublicKey: record.incomingPublicKey,
          outgoingWalletJson: record.outgoingWalletJson
        });
        var digest = this.app.crypto.hash(payload);
        return typeof digest === 'string' && /^[a-f0-9]{64}$/i.test(digest) ? digest.toLowerCase() : '';
      } catch (error) {
        return '';
      }
    }
  }, {
    key: "createWalletRollbackRecord",
    value: function createWalletRollbackRecord(outgoingWalletJson, outgoingPublicKey, incomingPublicKey) {
      var record = {
        version: WALLET_ROLLBACK_VERSION,
        phase: 'prepared',
        createdAt: this.walletNow(),
        outgoingPublicKey: outgoingPublicKey,
        incomingPublicKey: incomingPublicKey,
        outgoingWalletJson: outgoingWalletJson,
        integrity: ''
      };
      record.integrity = this.walletRollbackIntegrity(record);
      return record;
    }
  }, {
    key: "writeWalletRollbackRecord",
    value: function writeWalletRollbackRecord(record) {
      var storage = this.getWalletRecoveryStorage();
      if (!storage || !record || _typeof(record) !== 'object') return false;
      try {
        var stored = _objectSpread(_objectSpread({}, record), {}, {
          integrity: this.walletRollbackIntegrity(record)
        });
        if (!stored.integrity) return false;
        var serialized = JSON.stringify(stored);
        if (serialized.length > WALLET_ROLLBACK_MAX_BYTES) return false;
        storage.setItem(WALLET_ROLLBACK_STORAGE_KEY, serialized);
        return storage.getItem(WALLET_ROLLBACK_STORAGE_KEY) === serialized;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "readWalletRollbackRecord",
    value: function readWalletRollbackRecord() {
      var storage = this.getWalletRecoveryStorage();
      if (!storage) return Object.freeze({
        status: 'invalid'
      });
      var serialized;
      try {
        serialized = storage.getItem(WALLET_ROLLBACK_STORAGE_KEY);
      } catch (error) {
        return Object.freeze({
          status: 'invalid'
        });
      }
      if (serialized === null) return Object.freeze({
        status: 'none'
      });
      if (typeof serialized !== 'string' || serialized.length < 2 || serialized.length > WALLET_ROLLBACK_MAX_BYTES) {
        return Object.freeze({
          status: 'invalid'
        });
      }
      try {
        var record = JSON.parse(serialized);
        var now = this.walletNow();
        if (!record || _typeof(record) !== 'object' || Array.isArray(record) || record.version !== WALLET_ROLLBACK_VERSION || !['prepared', 'rolling_back', 'rollback_failed', 'finalized'].includes(record.phase) || !Number.isSafeInteger(record.createdAt) || record.createdAt < 0 || record.createdAt > now + 60000 || now - record.createdAt > WALLET_ROLLBACK_MAX_AGE_MS || typeof record.outgoingPublicKey !== 'string' || typeof record.incomingPublicKey !== 'string' || typeof record.outgoingWalletJson !== 'string' || typeof record.integrity !== 'string' || this.walletRollbackIntegrity(record) !== record.integrity.toLowerCase()) return Object.freeze({
          status: 'invalid'
        });
        var outgoing = this.normalizeWalletJson(record.outgoingWalletJson);
        if (!outgoing.ok || outgoing.publicKey !== record.outgoingPublicKey || !this.isWalletPublicKey(record.incomingPublicKey)) {
          return Object.freeze({
            status: 'invalid'
          });
        }
        return Object.freeze({
          status: 'valid',
          record: record
        });
      } catch (error) {
        return Object.freeze({
          status: 'invalid'
        });
      }
    }
  }, {
    key: "removeWalletRollbackRecord",
    value: function removeWalletRollbackRecord() {
      var storage = this.getWalletRecoveryStorage();
      if (!storage) return false;
      try {
        storage.removeItem(WALLET_ROLLBACK_STORAGE_KEY);
        return storage.getItem(WALLET_ROLLBACK_STORAGE_KEY) === null;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "verifyPersistedWallet",
    value: function () {
      var _verifyPersistedWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(expectedPublicKey) {
        var storage, livePublicKey, livePrivateKey, persisted, normalized, _t40;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              storage = this.getWalletRecoveryStorage();
              if (!(!storage || typeof expectedPublicKey !== 'string')) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2, false);
            case 1:
              _context17.p = 1;
              _context17.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              livePublicKey = _context17.v;
              _context17.n = 3;
              return this.app.wallet.getPrivateKey();
            case 3:
              livePrivateKey = _context17.v;
              if (!(livePublicKey !== expectedPublicKey || typeof livePrivateKey !== 'string' || this.app.crypto.generatePublicKey(livePrivateKey) !== expectedPublicKey || !this.app.options || !this.app.options.wallet || this.app.options.wallet.publicKey !== expectedPublicKey || this.app.options.wallet.privateKey !== livePrivateKey)) {
                _context17.n = 4;
                break;
              }
              return _context17.a(2, false);
            case 4:
              persisted = storage.getItem('options');
              normalized = this.normalizeWalletJson(persisted);
              return _context17.a(2, normalized.ok && normalized.publicKey === expectedPublicKey && JSON.parse(persisted).wallet.privateKey === livePrivateKey);
            case 5:
              _context17.p = 5;
              _t40 = _context17.v;
              return _context17.a(2, false);
          }
        }, _callee16, this, [[1, 5]]);
      }));
      function verifyPersistedWallet(_x10) {
        return _verifyPersistedWallet.apply(this, arguments);
      }
      return verifyPersistedWallet;
    }()
  }, {
    key: "importWalletForActivation",
    value: function () {
      var _importWalletForActivation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(walletJson) {
        var _this5 = this;
        var incoming, recovery, recognized, others, imported, Snapshot, Saito, snapshot, _iterator7, _step7, _loop2, _t41, _t42, _t43, _t44, _t45, _t46, _t47;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              if (!(!this.app.wallet || typeof this.app.wallet.onUpgrade !== 'function')) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2, false);
            case 1:
              _context19.p = 1;
              incoming = JSON.parse(walletJson); // This runs only inside the existing explicit import/rollback operation.
              // A failed collection read must not prevent the user restoring their wallet.
              _context19.n = 2;
              return this.readStickerRecovery(incoming.wallet.publicKey)["catch"](function () {
                return null;
              });
            case 2:
              recovery = _context19.v;
              if (recovery) {
                recognized = new Set(recovery.recognizedIds);
                others = (incoming.wallet.nfts || []).filter(function (nft) {
                  return !recognized.has(nft.id);
                });
                incoming.wallet.nfts = [].concat(_toConsumableArray(others), _toConsumableArray(recovery.recovery.map(function (item) {
                  return item.nft;
                })));
                walletJson = JSON.stringify(incoming);
              }
              _context19.n = 3;
              return this.app.wallet.onUpgrade('import', '', walletJson);
            case 3:
              _t41 = _context19.v;
              imported = _t41 === true;
              _t42 = imported && recovery;
              if (!_t42) {
                _context19.n = 5;
                break;
              }
              _context19.n = 4;
              return this.app.wallet.getPublicKey();
            case 4:
              _t43 = _context19.v;
              _t44 = recovery.owner;
              _t42 = _t43 === _t44;
            case 5:
              if (!_t42) {
                _context19.n = 18;
                break;
              }
              _context19.p = 6;
              // onUpgrade's generic snapshot counts NFT deposits as ordinary money.
              // At explicit import (no outgoing pending work), install the filtered
              // native snapshot while the independently restored NFT slips remain intact.
              Snapshot = require('saito-js/lib/balance_snapshot')["default"];
              Saito = require('saito-js/saito')["default"];
              snapshot = Snapshot.fromString(recovery.balanceSnapshot);
              if (!snapshot) {
                _context19.n = 7;
                break;
              }
              _context19.n = 7;
              return Saito.getInstance().updateBalanceFrom(snapshot);
            case 7:
              _iterator7 = _createForOfIteratorHelper(recovery.recovery);
              _context19.p = 8;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
                var item, tx, archived;
                return _regenerator().w(function (_context18) {
                  while (1) switch (_context18.n) {
                    case 0:
                      item = _step7.value;
                      tx = new Transaction();
                      tx.deserialize_from_web(_this5.app, item.transaction);
                      if (!(tx.signature === item.nft.tx_sig)) {
                        _context18.n = 2;
                        break;
                      }
                      _context18.n = 1;
                      return _this5.runBoundedWalletCheck(function () {
                        return _this5.app.storage.saveTransaction(tx, {
                          field1: 'Snake',
                          field4: item.nft.id,
                          preserve: 1
                        }, 'localhost');
                      });
                    case 1:
                      archived = _context18.v;
                      if (!(archived === WALLET_CHECK_TIMEOUT)) {
                        _context18.n = 2;
                        break;
                      }
                      return _context18.a(2, 1);
                    case 2:
                      return _context18.a(2);
                  }
                }, _loop2);
              });
              _iterator7.s();
            case 9:
              if ((_step7 = _iterator7.n()).done) {
                _context19.n = 12;
                break;
              }
              return _context19.d(_regeneratorValues(_loop2()), 10);
            case 10:
              if (!_context19.v) {
                _context19.n = 11;
                break;
              }
              return _context19.a(3, 12);
            case 11:
              _context19.n = 9;
              break;
            case 12:
              _context19.n = 14;
              break;
            case 13:
              _context19.p = 13;
              _t45 = _context19.v;
              _iterator7.e(_t45);
            case 14:
              _context19.p = 14;
              _iterator7.f();
              return _context19.f(14);
            case 15:
              _context19.n = 16;
              return this.app.wallet.saveWallet();
            case 16:
              _context19.n = 18;
              break;
            case 17:
              _context19.p = 17;
              _t46 = _context19.v;
            case 18:
              return _context19.a(2, imported);
            case 19:
              _context19.p = 19;
              _t47 = _context19.v;
              return _context19.a(2, false);
          }
        }, _callee17, this, [[8, 13, 14, 15], [6, 17], [1, 19]]);
      }));
      function importWalletForActivation(_x11) {
        return _importWalletForActivation.apply(this, arguments);
      }
      return importWalletForActivation;
    }()
  }, {
    key: "restoreOutgoingWallet",
    value: function () {
      var _restoreOutgoingWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(record) {
        var rollingBack, imported, verified, _t48;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              rollingBack = _objectSpread(_objectSpread({}, record), {}, {
                phase: 'rolling_back'
              });
              this.writeWalletRollbackRecord(rollingBack);
              _context20.n = 1;
              return this.importWalletForActivation(record.outgoingWalletJson);
            case 1:
              imported = _context20.v;
              _t48 = imported;
              if (!_t48) {
                _context20.n = 3;
                break;
              }
              _context20.n = 2;
              return this.verifyPersistedWallet(record.outgoingPublicKey);
            case 2:
              _t48 = _context20.v;
            case 3:
              verified = _t48;
              if (!(verified && this.removeWalletRollbackRecord())) {
                _context20.n = 4;
                break;
              }
              return _context20.a(2, true);
            case 4:
              this.writeWalletRollbackRecord(_objectSpread(_objectSpread({}, record), {}, {
                phase: 'rollback_failed'
              }));
              return _context20.a(2, false);
          }
        }, _callee18, this);
      }));
      function restoreOutgoingWallet(_x12) {
        return _restoreOutgoingWallet.apply(this, arguments);
      }
      return restoreOutgoingWallet;
    }()
  }, {
    key: "recoverInterruptedWalletActivation",
    value: function () {
      var _recoverInterruptedWalletActivation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var recovery, finalized;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              recovery = this.readWalletRollbackRecord();
              if (!(recovery.status === 'none')) {
                _context21.n = 1;
                break;
              }
              this.walletRecoveryState = 'ready';
              return _context21.a(2, Object.freeze({
                ok: true,
                recovered: false
              }));
            case 1:
              if (!(recovery.status !== 'valid')) {
                _context21.n = 2;
                break;
              }
              this.walletRecoveryState = 'blocked';
              return _context21.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'startup_recovery'));
            case 2:
              this.walletRecoveryState = 'recovering';
              if (!(recovery.record.phase === 'finalized')) {
                _context21.n = 4;
                break;
              }
              _context21.n = 3;
              return this.verifyPersistedWallet(recovery.record.incomingPublicKey);
            case 3:
              finalized = _context21.v;
              if (!(finalized && this.removeWalletRollbackRecord())) {
                _context21.n = 4;
                break;
              }
              this.walletRecoveryState = 'ready';
              return _context21.a(2, Object.freeze({
                ok: true,
                recovered: false
              }));
            case 4:
              _context21.n = 5;
              return this.restoreOutgoingWallet(recovery.record);
            case 5:
              if (!_context21.v) {
                _context21.n = 6;
                break;
              }
              this.walletRecoveryState = 'ready';
              return _context21.a(2, Object.freeze({
                ok: true,
                recovered: true
              }));
            case 6:
              this.walletRecoveryState = 'blocked';
              return _context21.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'startup_recovery'));
          }
        }, _callee19, this);
      }));
      function recoverInterruptedWalletActivation() {
        return _recoverInterruptedWalletActivation.apply(this, arguments);
      }
      return recoverInterruptedWalletActivation;
    }()
  }, {
    key: "ensureWalletRecovery",
    value: function ensureWalletRecovery() {
      if (this.walletRecoveryState === 'blocked') {
        return Promise.resolve(walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'startup_recovery'));
      }
      if (!this.walletRecoveryPromise) {
        this.walletRecoveryPromise = this.recoverInterruptedWalletActivation();
      }
      return this.walletRecoveryPromise;
    }
  }, {
    key: "requestWalletReload",
    value: function requestWalletReload() {
      try {
        if (typeof window === 'undefined' || !window.location || typeof window.location.reload !== 'function') return false;
        var reload = function reload() {
          try {
            window.location.reload();
          } catch (error) {}
        };
        if (typeof window.setTimeout === 'function') window.setTimeout(reload, 150);else reload();
        return true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "restoreWalletBackup",
    value: function restoreWalletBackup() {
      return this.activateWalletBackup('restore', true);
    }
  }, {
    key: "switchWalletBackup",
    value: function switchWalletBackup() {
      var warningsAcknowledged = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.activateWalletBackup('switch', warningsAcknowledged === true);
    }
  }, {
    key: "activateWalletBackup",
    value: function () {
      var _activateWalletBackup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(action, warningsAcknowledged) {
        var recovery, failure, rollbackRecord, clearCandidateOnExit, candidate, currentPublicKey, normalized, expectsSameWallet, assessment, warningsPresent, outgoingWalletJson, outgoing, finalized, _t49, _t50, _t51;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.p = _context22.n) {
            case 0:
              if (!this.walletActivationRunning) {
                _context22.n = 1;
                break;
              }
              return _context22.a(2, walletFailure('WALLET_SWITCH_PRECONDITION_CHANGED', 'precondition'));
            case 1:
              _context22.n = 2;
              return this.ensureWalletRecovery();
            case 2:
              recovery = _context22.v;
              if (!(!recovery || recovery.ok !== true)) {
                _context22.n = 3;
                break;
              }
              return _context22.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'startup_recovery'));
            case 3:
              this.walletActivationRunning = true;
              if (!this.stickerWalletSync) {
                _context22.n = 4;
                break;
              }
              _context22.n = 4;
              return this.stickerWalletSync;
            case 4:
              failure = null;
              rollbackRecord = null;
              clearCandidateOnExit = false;
              _context22.p = 5;
              candidate = this.walletImportCandidate;
              _context22.n = 6;
              return this.app.wallet.getPublicKey();
            case 6:
              currentPublicKey = _context22.v;
              normalized = candidate && this.normalizeWalletJson(candidate.walletJson);
              expectsSameWallet = action === 'restore';
              if (!(!candidate || !['restore', 'switch'].includes(action) || candidate.sameWallet !== expectsSameWallet || !normalized || !normalized.ok || candidate.currentPublicKey !== currentPublicKey || candidate.incomingPublicKey !== normalized.publicKey || expectsSameWallet !== (normalized.publicKey === currentPublicKey) || action === 'switch' && (!candidate.candidateHash || candidate.candidateHash !== this.walletCandidateFingerprint(candidate.walletJson)))) {
                _context22.n = 7;
                break;
              }
              clearCandidateOnExit = true;
              return _context22.a(2, walletFailure('WALLET_SWITCH_PRECONDITION_CHANGED', 'precondition'));
            case 7:
              if (!(action === 'switch')) {
                _context22.n = 10;
                break;
              }
              _context22.n = 8;
              return this.assessWalletSwitch(currentPublicKey);
            case 8:
              assessment = _context22.v;
              if (!(assessment.balanceState !== 'zero' && !this.walletBackupMatchesCandidate(candidate, currentPublicKey))) {
                _context22.n = 9;
                break;
              }
              return _context22.a(2, walletFailure('WALLET_SWITCH_BACKUP_REQUIRED', 'precondition'));
            case 9:
              warningsPresent = assessment.pendingState !== 'clear' || Boolean(assessment.registryName);
              if (!(warningsPresent && !warningsAcknowledged)) {
                _context22.n = 10;
                break;
              }
              return _context22.a(2, walletFailure('WALLET_SWITCH_ACKNOWLEDGEMENT_REQUIRED', 'precondition'));
            case 10:
              outgoingWalletJson = this.app.wallet.exportWallet();
              outgoing = this.normalizeWalletJson(outgoingWalletJson);
              if (!(!outgoing.ok || outgoing.publicKey !== currentPublicKey)) {
                _context22.n = 11;
                break;
              }
              clearCandidateOnExit = true;
              return _context22.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_STORE_FAILED', 'rollback_store'));
            case 11:
              rollbackRecord = this.createWalletRollbackRecord(outgoingWalletJson, currentPublicKey, normalized.publicKey);
              if (!(!rollbackRecord.integrity || !this.writeWalletRollbackRecord(rollbackRecord))) {
                _context22.n = 12;
                break;
              }
              clearCandidateOnExit = true;
              return _context22.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_STORE_FAILED', 'rollback_store'));
            case 12:
              clearCandidateOnExit = true;
              _context22.n = 13;
              return this.importWalletForActivation(normalized.walletJson);
            case 13:
              if (_context22.v) {
                _context22.n = 14;
                break;
              }
              failure = walletFailure('WALLET_SWITCH_IMPORT_FAILED', 'import');
              _context22.n = 18;
              break;
            case 14:
              _context22.n = 15;
              return this.verifyPersistedWallet(normalized.publicKey);
            case 15:
              if (_context22.v) {
                _context22.n = 16;
                break;
              }
              failure = walletFailure('WALLET_SWITCH_VERIFY_FAILED', 'verification');
              _context22.n = 18;
              break;
            case 16:
              finalized = _objectSpread(_objectSpread({}, rollbackRecord), {}, {
                phase: 'finalized'
              });
              if (!(!this.writeWalletRollbackRecord(finalized) || !this.removeWalletRollbackRecord())) {
                _context22.n = 17;
                break;
              }
              failure = walletFailure('WALLET_SWITCH_ROLLBACK_STORE_FAILED', 'finalize');
              _context22.n = 18;
              break;
            case 17:
              this.walletRecoveryState = 'ready';
              return _context22.a(2, Object.freeze({
                ok: true,
                action: action,
                publicKey: normalized.publicKey
              }));
            case 18:
              _t49 = rollbackRecord;
              if (!_t49) {
                _context22.n = 20;
                break;
              }
              _context22.n = 19;
              return this.restoreOutgoingWallet(rollbackRecord);
            case 19:
              _t49 = _context22.v;
            case 20:
              if (!_t49) {
                _context22.n = 21;
                break;
              }
              return _context22.a(2, failure);
            case 21:
              this.walletRecoveryState = 'blocked';
              return _context22.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'rollback'));
            case 22:
              _context22.p = 22;
              _t50 = _context22.v;
              _t51 = rollbackRecord;
              if (!_t51) {
                _context22.n = 24;
                break;
              }
              _context22.n = 23;
              return this.restoreOutgoingWallet(rollbackRecord);
            case 23:
              _t51 = _context22.v;
            case 24:
              if (!_t51) {
                _context22.n = 25;
                break;
              }
              return _context22.a(2, failure || walletFailure('WALLET_SWITCH_IMPORT_FAILED', 'import'));
            case 25:
              if (rollbackRecord) {
                _context22.n = 26;
                break;
              }
              clearCandidateOnExit = true;
              return _context22.a(2, failure || walletFailure('WALLET_SWITCH_PRECONDITION_CHANGED', 'precondition'));
            case 26:
              this.walletRecoveryState = 'blocked';
              return _context22.a(2, walletFailure('WALLET_SWITCH_ROLLBACK_FAILED', 'rollback'));
            case 27:
              _context22.p = 27;
              if (clearCandidateOnExit) {
                this.walletImportCandidate = null;
                this.walletBackupProof = null;
              }
              this.walletActivationRunning = false;
              return _context22.f(27);
            case 28:
              return _context22.a(2);
          }
        }, _callee20, this, [[5, 22, 27, 28]]);
      }));
      function activateWalletBackup(_x13, _x14) {
        return _activateWalletBackup.apply(this, arguments);
      }
      return activateWalletBackup;
    }()
  }, {
    key: "identityProtectionStorageKey",
    value: function () {
      var _identityProtectionStorageKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var publicKey, fingerprint, _t52;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              if (!(!this.app || this.app.BROWSER !== 1 || typeof window === 'undefined')) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2, '');
            case 1:
              _context23.p = 1;
              _context23.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              publicKey = _context23.v;
              if (!(!publicKey || !this.app.crypto || typeof this.app.crypto.hash !== 'function')) {
                _context23.n = 3;
                break;
              }
              return _context23.a(2, '');
            case 3:
              fingerprint = this.app.crypto.hash("snake-identity-protection:".concat(publicKey));
              return _context23.a(2, typeof fingerprint === 'string' && fingerprint ? "snake-identity-protection-".concat(fingerprint) : '');
            case 4:
              _context23.p = 4;
              _t52 = _context23.v;
              return _context23.a(2, '');
          }
        }, _callee21, this, [[1, 4]]);
      }));
      function identityProtectionStorageKey() {
        return _identityProtectionStorageKey.apply(this, arguments);
      }
      return identityProtectionStorageKey;
    }()
  }, {
    key: "qualifyIdentity",
    value: function () {
      var _qualifyIdentity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(rank) {
        var key, _t53;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              if (!(!Number.isSafeInteger(rank) || rank < 1 || rank > 10)) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2, null);
            case 1:
              _context24.n = 2;
              return this.identityProtectionStorageKey();
            case 2:
              key = _context24.v;
              if (key) {
                _context24.n = 3;
                break;
              }
              return _context24.a(2, null);
            case 3:
              _context24.p = 3;
              if (!(window.localStorage.getItem(key) === 'qualified')) {
                _context24.n = 4;
                break;
              }
              return _context24.a(2, Object.freeze({
                showCard: false,
                canReopen: true
              }));
            case 4:
              window.localStorage.setItem(key, 'qualified');
              return _context24.a(2, Object.freeze({
                showCard: true,
                canReopen: true
              }));
            case 5:
              _context24.p = 5;
              _t53 = _context24.v;
              return _context24.a(2, null);
          }
        }, _callee22, this, [[3, 5]]);
      }));
      function qualifyIdentity(_x15) {
        return _qualifyIdentity.apply(this, arguments);
      }
      return qualifyIdentity;
    }()
  }, {
    key: "identityProtectionAvailable",
    value: function () {
      var _identityProtectionAvailable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var key, _t54;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.p = _context25.n) {
            case 0:
              _context25.n = 1;
              return this.identityProtectionStorageKey();
            case 1:
              key = _context25.v;
              if (key) {
                _context25.n = 2;
                break;
              }
              return _context25.a(2, false);
            case 2:
              _context25.p = 2;
              return _context25.a(2, window.localStorage.getItem(key) === 'qualified');
            case 3:
              _context25.p = 3;
              _t54 = _context25.v;
              return _context25.a(2, false);
          }
        }, _callee23, this, [[2, 3]]);
      }));
      function identityProtectionAvailable() {
        return _identityProtectionAvailable.apply(this, arguments);
      }
      return identityProtectionAvailable;
    }()
  }, {
    key: "saveIdentity",
    value: function saveIdentity() {
      if (!this.app || this.app.BROWSER !== 1 || !this.saitoBackup) return false;
      try {
        this.app.connection.emit('saito-backup-render-request', {
          title: 'SAVE YOUR PLAYER IDENTITY',
          msg: 'Download a copy so you can keep your player identity if you switch devices.'
        });
        return true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "claimSaitoName",
    value: function claimSaitoName() {
      if (!this.app || this.app.BROWSER !== 1) return false;
      try {
        var registry = this.app.modules && this.app.modules.returnModule('Registry');
        if (!registry) return false;
        this.app.connection.emit('register-username-or-login', {
          msg: 'Claim a Saito name for future Snake runs.'
        });
        return true;
      } catch (error) {
        return false;
      }
    }
  }, {
    key: "signScore",
    value: function () {
      var _signScore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(entry, ownerPublicKey) {
        var data, publicKey, transaction, serializedTransaction, _t55;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.p = _context26.n) {
            case 0:
              if (!(!this.app || this.app.BROWSER !== 1)) {
                _context26.n = 1;
                break;
              }
              return _context26.a(2, null);
            case 1:
              data = shared.createScoreData(entry);
              if (!(!data || typeof ownerPublicKey !== 'string' || ownerPublicKey !== ownerPublicKey.trim() || ownerPublicKey.length < 1 || ownerPublicKey.length > 128)) {
                _context26.n = 2;
                break;
              }
              return _context26.a(2, null);
            case 2:
              _context26.p = 2;
              _context26.n = 3;
              return this.app.wallet.getPublicKey();
            case 3:
              publicKey = _context26.v;
              if (!(!publicKey || publicKey !== ownerPublicKey)) {
                _context26.n = 4;
                break;
              }
              return _context26.a(2, null);
            case 4:
              _context26.n = 5;
              return this.app.wallet.createUnsignedTransaction(publicKey, BigInt(0), BigInt(0));
            case 5:
              transaction = _context26.v;
              if (transaction) {
                _context26.n = 6;
                break;
              }
              return _context26.a(2, null);
            case 6:
              transaction.msg = {
                module: 'Snake',
                request: 'snake score',
                data: data
              };
              _context26.n = 7;
              return transaction.sign();
            case 7:
              serializedTransaction = transaction.serialize_to_web(this.app);
              if (!(!serializedTransaction || !transaction.signature)) {
                _context26.n = 8;
                break;
              }
              return _context26.a(2, null);
            case 8:
              return _context26.a(2, Object.freeze({
                serializedTransaction: serializedTransaction,
                signature: transaction.signature,
                walletPublicKey: publicKey
              }));
            case 9:
              _context26.p = 9;
              _t55 = _context26.v;
              return _context26.a(2, null);
          }
        }, _callee24, this, [[2, 9]]);
      }));
      function signScore(_x16, _x17) {
        return _signScore.apply(this, arguments);
      }
      return signScore;
    }()
  }, {
    key: "propagateScore",
    value: function () {
      var _propagateScore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(serializedTransaction) {
        var transaction, _t56;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              if (!(!this.app || this.app.BROWSER !== 1 || typeof serializedTransaction !== 'string')) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2, false);
            case 1:
              _context27.p = 1;
              transaction = new Transaction();
              transaction.deserialize_from_web(this.app, serializedTransaction);
              if (transaction.signature) {
                _context27.n = 2;
                break;
              }
              return _context27.a(2, false);
            case 2:
              _context27.n = 3;
              return this.app.network.propagateTransaction(transaction);
            case 3:
              return _context27.a(2, true);
            case 4:
              _context27.p = 4;
              _t56 = _context27.v;
              return _context27.a(2, false);
          }
        }, _callee25, this, [[1, 4]]);
      }));
      function propagateScore(_x18) {
        return _propagateScore.apply(this, arguments);
      }
      return propagateScore;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(blk, tx, conf) {
        var _txmsg, _txmsg2, _txmsg3;
        var txmsg, data, signer, signature, leaderboard, replay, result, observedAt, runStorage, association, blockEvidence, candidate, resolution, _t57, _t58;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              if (!(Number(conf) !== 0 || !this.app || this.app.BROWSER === 1 || !this.runStorageReady)) {
                _context28.n = 1;
                break;
              }
              return _context28.a(2);
            case 1:
              _context28.p = 1;
              txmsg = tx && tx.returnMessage();
              _context28.n = 3;
              break;
            case 2:
              _context28.p = 2;
              _t57 = _context28.v;
              return _context28.a(2);
            case 3:
              if (!(((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.module) !== 'Snake' || ((_txmsg2 = txmsg) === null || _txmsg2 === void 0 ? void 0 : _txmsg2.request) !== 'snake score' || ((_txmsg3 = txmsg) === null || _txmsg3 === void 0 || (_txmsg3 = _txmsg3.data) === null || _txmsg3 === void 0 ? void 0 : _txmsg3.version) !== 2)) {
                _context28.n = 4;
                break;
              }
              return _context28.a(2);
            case 4:
              data = shared.createScoreData(txmsg.data);
              signer = tx && tx.from && tx.from[0] && tx.from[0].publicKey;
              signature = tx && tx.signature;
              if (!(!data || typeof signer !== 'string' || !signer || typeof signature !== 'string' || !signature)) {
                _context28.n = 5;
                break;
              }
              return _context28.a(2);
            case 5:
              _context28.p = 5;
              leaderboard = loadServerLeaderboard();
              replay = shared.normalizeReplay(data.run, data.ruleset);
              if (!(!replay || leaderboard.fingerprintReplay(replay) !== data.fingerprint)) {
                _context28.n = 6;
                break;
              }
              return _context28.a(2);
            case 6:
              result = leaderboard.verifyRun(replay.run);
              if (!(!result || result.score !== data.score)) {
                _context28.n = 7;
                break;
              }
              return _context28.a(2);
            case 7:
              observedAt = Date.now();
              runStorage = loadServerRunStorage();
              _context28.n = 8;
              return runStorage.associateVerifiedRun(this.app.storage, this.dbname, {
                fingerprint: data.fingerprint,
                name: data.name,
                score: data.score,
                eaten: result.eaten,
                replay: replay,
                walletPublicKey: signer,
                transactionSignature: signature,
                associatedAt: observedAt
              });
            case 8:
              association = _context28.v;
              blockEvidence = normalizeBlockEvidence(blk, observedAt);
              if (!(association.status === 'associated' && blockEvidence)) {
                _context28.n = 10;
                break;
              }
              candidate = _objectSpread({
                fingerprint: data.fingerprint,
                transactionSignature: signature
              }, blockEvidence);
              _context28.n = 9;
              return loadServerReceiptService().recordCanonicalCallback(this.app.storage, this.dbname, this.app.blockchain, blk, candidate);
            case 9:
              resolution = _context28.v;
              if (resolution.state !== 'observed' && (resolution.reason === 'transaction_missing' || resolution.reason === 'noncanonical')) {
                console.info('Snake receipt', {
                  event: 'receipt_block_rejected',
                  fingerprint: data.fingerprint.slice(0, 12),
                  reason: resolution.reason
                });
              }
            case 10:
              if (association.status === 'associated') {
                console.info('Snake provenance', {
                  event: 'provenance_associated',
                  fingerprint: data.fingerprint.slice(0, 12)
                });
              }
              _context28.n = 12;
              break;
            case 11:
              _context28.p = 11;
              _t58 = _context28.v;
            case 12:
              return _context28.a(2);
          }
        }, _callee26, this, [[5, 11], [1, 2]]);
      }));
      function onConfirmation(_x19, _x20, _x21) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "scheduleReceiptReconciliation",
    value: function scheduleReceiptReconciliation() {
      var _this6 = this;
      if (!this.runStorageReady || !this.app || this.app.BROWSER === 1 || !this.app.blockchain || this.receiptReconciliationTimer) {
        return false;
      }
      this.receiptReconciliationTimer = setTimeout(function () {
        _this6.receiptReconciliationTimer = null;
        _this6.receiptReconciliationPromise = _this6.reconcileBlockEvidence()["catch"](function () {
          return null;
        });
      }, this.receiptReconciliationDelayMs);
      if (typeof this.receiptReconciliationTimer.unref === 'function') {
        this.receiptReconciliationTimer.unref();
      }
      return true;
    }
  }, {
    key: "reconcileBlockEvidence",
    value: function () {
      var _reconcileBlockEvidence = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        var summary;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              if (!(!this.runStorageReady || !this.app || !this.app.blockchain)) {
                _context29.n = 1;
                break;
              }
              return _context29.a(2, null);
            case 1:
              _context29.n = 2;
              return loadServerReceiptService().reconcileBlockEvidence(this.app.storage, this.dbname, this.app.blockchain, Date.now());
            case 2:
              summary = _context29.v;
              console.info('Snake receipt', _objectSpread({
                event: 'receipt_reconciliation_complete'
              }, summary));
              return _context29.a(2, summary);
          }
        }, _callee27, this);
      }));
      function reconcileBlockEvidence() {
        return _reconcileBlockEvidence.apply(this, arguments);
      }
      return reconcileBlockEvidence;
    }()
  }, {
    key: "onChainReorganization",
    value: function onChainReorganization(blockId, blockHash, lc) {
      return this.handleChainReorganization(blockId, blockHash, lc)["catch"](function () {
        return false;
      });
    }
  }, {
    key: "handleChainReorganization",
    value: function () {
      var _handleChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(blockId, blockHash, lc) {
        var evidence, summary, block, loaded, _iterator8, _step8, transaction, _t59;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.p = _context30.n) {
            case 0:
              if (!(!this.runStorageReady || !this.app || this.app.BROWSER === 1)) {
                _context30.n = 1;
                break;
              }
              return _context30.a(2, false);
            case 1:
              evidence = normalizeBlockEvidence({
                id: blockId,
                hash: blockHash
              }, Date.now());
              if (!(!evidence || lc !== true && lc !== false && Number(lc) !== 0 && Number(lc) !== 1)) {
                _context30.n = 2;
                break;
              }
              return _context30.a(2, false);
            case 2:
              if (!(lc === false || Number(lc) === 0)) {
                _context30.n = 4;
                break;
              }
              _context30.n = 3;
              return loadServerReceiptService().clearBlockEvidenceAt(this.app.storage, this.dbname, evidence.blockId, evidence.blockHash);
            case 3:
              summary = _context30.v;
              if (summary.cleared > 0) {
                console.info('Snake receipt', {
                  event: 'receipt_reorg_removed',
                  blockId: evidence.blockId,
                  blockHash: evidence.blockHash.slice(0, 12),
                  cleared: summary.cleared
                });
              }
              return _context30.a(2, true);
            case 4:
              if (!(!this.app.blockchain || typeof this.app.blockchain.getBlock !== 'function')) {
                _context30.n = 5;
                break;
              }
              return _context30.a(2, false);
            case 5:
              _context30.n = 6;
              return this.app.blockchain.getBlock(evidence.blockHash, true);
            case 6:
              block = _context30.v;
              loaded = normalizeBlockEvidence(block, evidence.observedAt);
              if (!(!loaded || loaded.blockId !== evidence.blockId || loaded.blockHash !== evidence.blockHash || !Array.isArray(block.transactions))) {
                _context30.n = 7;
                break;
              }
              return _context30.a(2, false);
            case 7:
              _iterator8 = _createForOfIteratorHelper(block.transactions);
              _context30.p = 8;
              _iterator8.s();
            case 9:
              if ((_step8 = _iterator8.n()).done) {
                _context30.n = 11;
                break;
              }
              transaction = _step8.value;
              _context30.n = 10;
              return this.onConfirmation(block, transaction, 0);
            case 10:
              _context30.n = 9;
              break;
            case 11:
              _context30.n = 13;
              break;
            case 12:
              _context30.p = 12;
              _t59 = _context30.v;
              _iterator8.e(_t59);
            case 13:
              _context30.p = 13;
              _iterator8.f();
              return _context30.f(13);
            case 14:
              console.info('Snake receipt', {
                event: 'receipt_reorg_added',
                blockId: evidence.blockId,
                blockHash: evidence.blockHash.slice(0, 12)
              });
              return _context30.a(2, true);
          }
        }, _callee28, this, [[8, 12, 13, 14]]);
      }));
      function handleChainReorganization(_x22, _x23, _x24) {
        return _handleChainReorganization.apply(this, arguments);
      }
      return handleChainReorganization;
    }()
  }, {
    key: "returnLeaderboard",
    value: function () {
      var _returnLeaderboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(app) {
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              if (this.runStorageReady) {
                _context31.n = 1;
                break;
              }
              throw new Error('Run storage is not ready.');
            case 1:
              return _context31.a(2, loadServerRunStorage().returnLeaderboard(app.storage, this.dbname));
          }
        }, _callee29, this);
      }));
      function returnLeaderboard(_x25) {
        return _returnLeaderboard.apply(this, arguments);
      }
      return returnLeaderboard;
    }() //
    // The node sits behind a proxy and express is not configured to trust it,
    // so req.ip is the proxy for everybody. Without this every player on the
    // site would share a single rate-limit bucket.
    //
  }, {
    key: "returnClientAddress",
    value: function returnClientAddress(req) {
      var headers = req && req.headers || {};
      var forwarded = headers['cf-connecting-ip'] || headers['x-real-ip'] || (typeof headers['x-forwarded-for'] === 'string' ? headers['x-forwarded-for'].split(',')[0] : '');
      var address = String(forwarded || '').trim();
      if (address) {
        return address;
      }
      return req && req.ip || req && req.socket && req.socket.remoteAddress || 'unknown';
    }

    //
    // one submission per address every few seconds, so nobody can pin the node
    // down replaying long games at it
    //
  }, {
    key: "rateLimited",
    value: function rateLimited(address, now) {
      var previous = this.submissionTimes.get(address) || 0;
      if (now - previous < RATE_LIMIT_MS) {
        return true;
      }
      if (this.submissionTimes.size >= RATE_LIMIT_MAX_TRACKED) {
        var _iterator9 = _createForOfIteratorHelper(this.submissionTimes),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _step9$value = _slicedToArray(_step9.value, 2),
              key = _step9$value[0],
              seen = _step9$value[1];
            if (now - seen >= RATE_LIMIT_MS) {
              this.submissionTimes["delete"](key);
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
      this.submissionTimes.set(address, now);
      return false;
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var _this7 = this,
        _this$stickerService;
      var modSelf = this;
      var leaderboard = loadServerLeaderboard();
      if (this.stickerService) this.stickerService.routes(expressapp, function (req) {
        return _this7.returnClientAddress(req);
      });else expressapp.get('/snake/sticker-protocol.js', function (req, res) {
        return res.sendFile(__dirname + '/sticker-protocol.js');
      });
      (_this$stickerService = this.stickerService) === null || _this$stickerService === void 0 || (_this$stickerService = _this$stickerService.daily) === null || _this$stickerService === void 0 || _this$stickerService.routes(expressapp);
      expressapp.get('/snake/daily-protocol.js', function (req, res) {
        return res.sendFile(eval('require')('node:path').join(__dirname, 'daily-protocol.js'));
      });
      expressapp.get('/snake/api/leaderboard', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(req, res) {
          var _t60, _t61, _t62;
          return _regenerator().w(function (_context32) {
            while (1) switch (_context32.p = _context32.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                _context32.p = 1;
                _t60 = res;
                _context32.n = 2;
                return modSelf.returnLeaderboard(app);
              case 2:
                _t61 = _context32.v;
                return _context32.a(2, _t60.json.call(_t60, {
                  entries: _t61
                }));
              case 3:
                _context32.p = 3;
                _t62 = _context32.v;
                return _context32.a(2, res.status(500).json({
                  error: 'Leaderboard unavailable.'
                }));
            }
          }, _callee30, null, [[1, 3]]);
        }));
        return function (_x26, _x27) {
          return _ref3.apply(this, arguments);
        };
      }());
      expressapp.get('/snake/api/performance', function (req, res) {
        res.setHeader('Cache-Control', 'no-store');
        if (!performanceRequestAllowed(req, modSelf.performanceCaptureEnabled)) {
          return res.status(404).json({
            error: 'Not found.'
          });
        }
        return res.json({
          stagingOnly: true,
          captures: modSelf.performanceCaptures
        });
      });
      expressapp.post('/snake/api/performance', function (req, res) {
        res.setHeader('Cache-Control', 'no-store');
        if (!performanceRequestAllowed(req, modSelf.performanceCaptureEnabled)) {
          return res.status(404).json({
            error: 'Not found.'
          });
        }
        var capture = normalizePerformanceCapture(req && req.body);
        if (!capture) {
          return res.status(400).json({
            error: 'Invalid performance capture.'
          });
        }
        var stored = Object.freeze(_objectSpread({
          receivedAt: Date.now()
        }, capture));
        var existingIndex = modSelf.performanceCaptures.findIndex(function (item) {
          return item.runId === stored.runId;
        });
        if (existingIndex >= 0) modSelf.performanceCaptures.splice(existingIndex, 1);
        modSelf.performanceCaptures.push(stored);
        if (modSelf.performanceCaptures.length > PERFORMANCE_CAPTURE_LIMIT) {
          modSelf.performanceCaptures.splice(0, modSelf.performanceCaptures.length - PERFORMANCE_CAPTURE_LIMIT);
        }
        try {
          console.info('Snake staging performance capture', JSON.stringify({
            runId: stored.runId,
            durationMs: stored.durationMs,
            summary: stored.summary
          }));
        } catch (error) {}
        return res.json({
          accepted: true,
          runId: stored.runId
        });
      });
      expressapp.get('/snake/api/runs/:fingerprint/association', /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(req, res) {
          var status, _t63;
          return _regenerator().w(function (_context33) {
            while (1) switch (_context33.p = _context33.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                if (modSelf.runStorageReady) {
                  _context33.n = 1;
                  break;
                }
                return _context33.a(2, res.status(503).json({
                  error: 'Leaderboard unavailable.'
                }));
              case 1:
                _context33.p = 1;
                _context33.n = 2;
                return loadServerReceiptService().returnCanonicalAssociationStatus(app.storage, modSelf.dbname, app.blockchain, req && req.params && req.params.fingerprint, Date.now());
              case 2:
                status = _context33.v;
                if (status) {
                  _context33.n = 3;
                  break;
                }
                return _context33.a(2, res.status(404).json({
                  error: 'Run not found.'
                }));
              case 3:
                return _context33.a(2, res.json(status));
              case 4:
                _context33.p = 4;
                _t63 = _context33.v;
                return _context33.a(2, res.status(500).json({
                  error: 'Association status unavailable.'
                }));
            }
          }, _callee31, null, [[1, 4]]);
        }));
        return function (_x28, _x29) {
          return _ref4.apply(this, arguments);
        };
      }());
      expressapp.get('/snake/api/runs/:fingerprint/proof', /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(req, res) {
          var proof, _t64, _t65, _t66, _t67, _t68, _t69;
          return _regenerator().w(function (_context34) {
            while (1) switch (_context34.p = _context34.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                if (modSelf.runStorageReady) {
                  _context34.n = 1;
                  break;
                }
                return _context34.a(2, res.status(503).json({
                  error: 'Leaderboard unavailable.'
                }));
              case 1:
                _context34.p = 1;
                _context34.n = 2;
                return loadServerReceiptService().returnCanonicalRunProof(app.storage, modSelf.dbname, app.blockchain, req && req.params && req.params.fingerprint, Date.now());
              case 2:
                proof = _context34.v;
                if (proof) {
                  _context34.n = 3;
                  break;
                }
                return _context34.a(2, res.status(404).json({
                  error: 'Run proof not found.'
                }));
              case 3:
                _t64 = res;
                _t65 = _objectSpread;
                _t66 = _objectSpread({}, proof);
                _t67 = {};
                _context34.n = 4;
                return modSelf.syncStatus.read();
              case 4:
                _t68 = _context34.v;
                return _context34.a(2, _t64.json.call(_t64, _t65(_t66, _t67, {
                  sync: _t68
                })));
              case 5:
                _context34.p = 5;
                _t69 = _context34.v;
                return _context34.a(2, res.status(500).json({
                  error: 'Run proof unavailable.'
                }));
            }
          }, _callee32, null, [[1, 5]]);
        }));
        return function (_x30, _x31) {
          return _ref5.apply(this, arguments);
        };
      }());
      expressapp.post('/snake/api/leaderboard', /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(req, res) {
          var body, name, address, now, replay, result, fingerprint, recorded, _t70, _t71, _t72, _t73, _t74, _t75, _t76;
          return _regenerator().w(function (_context35) {
            while (1) switch (_context35.p = _context35.n) {
              case 0:
                res.setHeader('Cache-Control', 'no-store');
                _context35.p = 1;
                if (modSelf.runStorageReady) {
                  _context35.n = 2;
                  break;
                }
                return _context35.a(2, res.status(503).json({
                  error: 'Leaderboard unavailable.'
                }));
              case 2:
                body = req.body || {};
                name = leaderboard.sanitizeName(body.name);
                if (name) {
                  _context35.n = 3;
                  break;
                }
                return _context35.a(2, res.status(400).json({
                  error: 'Use 1-16 letters, numbers, spaces, _ or -.'
                }));
              case 3:
                address = modSelf.returnClientAddress(req);
                now = Date.now();
                if (!modSelf.rateLimited(address, now)) {
                  _context35.n = 4;
                  break;
                }
                return _context35.a(2, res.status(429).json({
                  error: 'Please wait a moment before submitting again.'
                }));
              case 4:
                replay = shared.normalizeReplay(body.run);
                if (replay) {
                  _context35.n = 5;
                  break;
                }
                return _context35.a(2, res.status(400).json({
                  error: 'That run could not be verified.'
                }));
              case 5:
                // the score is not taken on trust: the run is replayed here against
                // the same seeded logic the browser ran
                result = leaderboard.verifyRun(replay.run);
                if (!(!result || result.score < 1)) {
                  _context35.n = 6;
                  break;
                }
                return _context35.a(2, res.status(400).json({
                  error: 'That run could not be verified.'
                }));
              case 6:
                fingerprint = leaderboard.fingerprintReplay(replay);
                _context35.n = 7;
                return loadServerRunStorage().recordVerifiedRun(app.storage, modSelf.dbname, {
                  name: name,
                  score: result.score,
                  eaten: result.eaten,
                  achievedAt: now,
                  replay: replay,
                  fingerprint: fingerprint
                });
              case 7:
                recorded = _context35.v;
                _t70 = res;
                _t71 = recorded.duplicate;
                _t72 = recorded.entry.score;
                _t73 = recorded.entry;
                _t74 = recorded.rank;
                _context35.n = 8;
                return modSelf.returnLeaderboard(app);
              case 8:
                _t75 = _context35.v;
                return _context35.a(2, _t70.json.call(_t70, {
                  accepted: true,
                  duplicate: _t71,
                  score: _t72,
                  entry: _t73,
                  rank: _t74,
                  entries: _t75
                }));
              case 9:
                _context35.p = 9;
                _t76 = _context35.v;
                return _context35.a(2, res.status(500).json({
                  error: 'Could not record that score.'
                }));
            }
          }, _callee33, null, [[1, 9]]);
        }));
        return function (_x32, _x33) {
          return _ref6.apply(this, arguments);
        };
      }());

      // the template serves web/ statically at /snake
      return _superPropGet(Snake, "webServer", this, 3)([app, expressapp, express]);
    }
  }]);
}(ModTemplate);
module.exports = Snake;
module.exports.normalizeRegistryName = shared.normalizeRegistryName;
module.exports.SNAKE_WALLET_RUNTIME_READY_EVENT = SNAKE_WALLET_RUNTIME_READY_EVENT;